
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FlipCard extends Vue {
	@Prop({ required: true })
	public flipped!: boolean;
}
